<template>
	<Sider :collapsed-width="78" :style="{position: 'fixed', height:'calc(100vh - 64px)', left:showLeftPx?0:'-260px', overflow: 'auto', 'z-index':1011,top:'60px',paddingTop:'20px'}">
		<Menu  ref="menu" class="menu-view" theme="light" :active-name="activeObj.activeId" :open-names="[openedNames]"  :accordion="accordion"  @on-select='selectMenu'>
            <div v-for="(item1,index1) in memuList" :key="index1">
				
                <side-menu-item v-if="showChildren(item1)"  :key="`menu-${item1.id}`" :parent-item="item1"></side-menu-item>
                <menu-item v-if="!showChildren(item1)" :name="item1.id+'-'+item1.children[0].id" :key="`menu-${item1.children[0].name}`" class="menuItemW" id='menuItemW'>
					<div class="test flexCC" :ref='"test"+index1' >
                       	<i  class="iconfont" :class="item1.icon" :style="{'font-size': '18px','margin-right':item1.routeName=='sceneModelPage'?'7px':'8px'}"></i>
					    <div :style="{flexShrink:0, maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }">{{ showTitle(item1.children[0]) }}</div>
					</div>
				</menu-item>
			</div>
		</Menu>
	</Sider>
</template>
<script>
	import common from "../../../common/common.js";
	import mixin from './mixin'
	import { getUnion } from '@/libs/tools'
	import SideMenuItem from './side-menu-item.vue'
    import { mapState } from 'vuex';
    

	export default {
		name: "Side",
		mixins: [ mixin ],
		components: {
           SideMenuItem
        },
		data() {
			return {
				offhome: true,
                colorHome: "#4ABAF0", //设置首页菜单的背景色  高亮
				accordion:true,//手风琴
                memuList:[],
                memuList1:[// 管理员登录侧边栏显示
					{
						id: 0,
						name: '平台首页',
						routeName:'home',
						icon:'icon-activeHome-copy-copy-copy',
						children: [
						   {
							    id: 1,
							    name: "平台首页",
							    routeName:'home',
							    route: "/"
						   }
						]
					},
					{
						id: 1,
						name: '产品模板',
						routeName:'templateProduct',
						icon:'icon-guanli',
						children: [
						    {
					        	id: 1,
					        	name: "基础型号",
					        	routeName:'BasicProduct',
					        	route: "basicProduct"
						   },
						]
					},
					{
						id: 2,
						name: '产品页面',
						routeName:'pageProduct',
						icon:'icon-yemianpeizhi',
						children: [
						    {
					            id: 1,
							    name: "产品页面",
							    routeName:'Pages',
							    route: "productPage"
						   },
						]
					},
					{
						id: 3,
						name: '页面升级',
						routeName:'pageDevice',
						icon:'icon-appshengji',
						children: [
						    {
					            id: 1,
							    name: "页面升级",
							    routeName:'appDevice',
							    route: "appDevice"
						   },
						]
					},
					{
						id: 4,
						name: '控件页面',
						routeName:'uiControllerPage',
						icon:'icon-shebeiguanli',
						children: [
						    {
					            id: 1,
							    name: "控件页面",
							    routeName:'UiController',
							    route: "uiController"
						   },
						]
					},
					{
						id: 5,
						name: "固件管理",
						routeName: "firmwareVersionPage",
						icon:'icon-gujianguanli',
						children: [
						    {
					            id: 1,
							    name: "固件管理",
							    routeName:'firmwareVersion',
								route: "firmwareVersion"
						   },
						]
						
					}
				],
				memuList2: [// roleType==2
					{
						id: 0,
						name: '平台首页',
						routeName:'home',
						icon:'icon-activeHome-copy-copy-copy',
						children: [{
							id: 1,
							name: "平台首页",
							routeName:'home',
							route: "/"
						   }
						]
					},
					{
						id: 1,
						name: '产品管理',
						routeName:'Products',
						icon:'icon-guanli',
						children: [{
							id: 1,
							name: "产品管理",
							routeName:'Products',
							route: "productManage"
						   }
						]
					},
					{
						id: 2,
						name: '产品页面',
						routeName:'Pages',
						icon:'icon-yemianpeizhi',
						children: [{
							id: 1,
							name: "产品页面",
							routeName:'Pages',
							route: "productPage"
						}]
					},
					{
						id: 13,
						name: "场景模型",
						routeName: "sceneModelPage",
						icon:'icon-moxingguanli',
						children: [
						    {
					            id: 1,
							    name: "场景模型",
							    routeName:'sceneModel',
								route: "sceneModel"
						   },
						]
						
					},
					{
						id: 3,
						name: '订单管理',
						routeName: "Order",
						icon:'icon-dingdanguanli',
						children: [{
							id: 1,
							name: "订单管理",
							routeName:'Order',
							route: "orderManage"
						}]
					},
					{
						id: 4,
						name: '用户管理',
						route: "userManage",
						icon:'icon-Management',
						routeName: "User",
						children: [{
							id: 1,
							name: "用户管理",
							routeName: "User",
							route: "userManage"
						}]
					},
					{
						id: 14,
						name: '安装商管理',
						route: "Installer",
						icon:'icon-jianshe',
						routeName: "Installer",
						children: [{
							id: 1,
							name: "安装商管理",
							routeName: "Installer",
							route: "installerManage"
						}]
					},
					{
						id: 5,
						name: '登录统计',
						route: "Login",
						routeName: "Login",
						icon:'icon-gupiao',
						children: [{
							id: 1,
							name: "登录统计",
							routeName: "Login",
							route: "loginStatistics"
						}]
                    },
					{
						id: 6,
						name: '设备管理',
						route: "DeviceCenter",
						routeName: "DeviceCenter",
						icon:'icon-shebeiguanli',
						children: [{
							id: 1,
							name: "设备管理",
							routeName: "Device",
							route: "deviceManage"
						},
						{
							id: 2,
							name: "设备位置",
							routeName: "Location",
							route: "deviceLocation"
						}
						]
                    },
                    {
						id: 7,
						name: '固件中心',
						route: "firmwareCenter",
						routeName: "firmwareCenter",
						icon:'icon-gujianguanli',
						children: [
						// {
						// 	id: 1,
						// 	name: "固件管理",
						// 	routeName: "firmwareVersion",
						// 	route: "firmwareVersion"
						// },
						{
							id: 2,
							name: "计划管理",
							routeName: "firmwarePlan",
							route: "firmwarePlan"
						},
						{
							id: 3,
							name: "下载历史",
							routeName: "firmwareDownload",
							route: "firmwareDownload"
						}]
                    },
                    {
						id: 8,
						name: '应用中心',
						route: "AppCenter",
						routeName: "AppCenter",
						icon:'icon-yingyong',
						children: [
						{
                                id: 1,
                                name: "版本管理",
								routeName: "appVersion",
                                route: "appVersion"
                            },
                            // {
                            //     id: 2,
                            //     name: "页面升级",
							// 	routeName: "appDevice",
                            //     route: "appDevice"
                            // },
                            {
                                id: 3,
                                name: "计划管理",
								routeName: "appPlan",
                                route: "appPlan"
                            },
							{
							id: 4,
							name: "下载历史",
							routeName: "appDownload",
							route: "appDownload"
					    	},
							{
                                id: 5,
                                name: "引导页",
								routeName: "onboardingBanner",
                                route: "onboardingBanner"
                            },
                        ]
                    },
                    {
						id: 9,
						name: '交易中心',
						route: "AccountCenter",
						routeName: "AccountCenter",
						icon:'icon-jiaoyizhongxin-01',
						children: [
                            {
                                id: 1,
                                name: "月度短信",
								routeName: "SMScost",
                                route: "SMScost"
                            },
                            {
                                id: 2,
                                name: "充值管理",
								routeName: "accountRecharge",
                                route: "accountRecharge"
                            },
                            {
                                id: 3,
                                name: "交易历史",
								routeName: "accountHistory",
                                route: "accountHistory"
                            }
                        ]
                    },
                    {
						id: 10,
						name: '反馈信息',
						route: "feedBack",
						routeName: "feedBack",
						icon:'icon-fankui',
						children: [
                            {
                                id: 1,
                                name: "反馈信息",
								routeName:'feedBack',
                                route: "feedBack"
                            }
                        ]
                    },
                    {
						id: 11,
						name: '推送信息',
						route: "pushMessage",
						routeName:'pushMessage',
						icon:'icon-tuisong',
						children: [
                            {
                                id: 1,
                                name: "推送信息",
								routeName:'pushMessage',
                                route: "pushMessage"
                            },
                        ]
					},
					{
						id: 12,
						name: '配置管理',
						route: "setting",
						routeName:'setting',
						icon:'icon-shezhi1',
						children: [
                            {
                                id: 1,
                                name: "设置",
								routeName:'setting',
                                route: "setting"
                            }
                        ]
					},
		
					// {
					// 	id: 112,
					// 	title: '测试',
					// 	children: [{
					// 		id: 1,
					// 		title: "测试",
					// 		routerUrl: "modelss"
					// 	}]
					// },
				],
				memuList3: [// roleType==1
					{
						id: 0,
						name: '平台首页',
						routeName:'home',
						icon:'icon-activeHome-copy-copy-copy',
						children: [{
							id: 1,
							name: "平台首页",
							routeName:'home',
							route: "/"
						   }
						]
					},
					{
						id: 1,
						name: '产品中心',
						routeName:'Products',
						icon:'icon-guanli',
						children: [{
							id: 1,
							name: "产品管理",
							routeName:'Products',
							route: "productManage"
						   },
					       {
					        	id: 2,
					        	name: "产品页面",
					        	routeName:'Pages',
					        	route: "productPage"
						   },
					    //    {
					    //     	id: 3,
					    //     	name: "基础型号",
					    //     	routeName:'BasicProduct',
					    //     	route: "basicProduct"
						//    },
					        {
					        	id: 4,
					        	name: "订单管理",
					        	routeName:'Order',
					        	route: "orderManage"
					        },
						]
					},
					{
						id: 13,
						name: "场景模型",
						routeName: "sceneModelPage",
						icon:'icon-moxingguanli',
						children: [
						    {
					            id: 1,
							    name: "场景模型",
							    routeName:'sceneModel',
								route: "sceneModel"
						   },
						]
						
					},
					{
						id: 2,
						name: '设备管理',
						route: "DeviceCenter",
						routeName: "DeviceCenter",
						icon:'icon-shebeiguanli',
						children: [{
							id: 1,
							name: "设备管理",
							routeName: "Device",
							route: "deviceManage"
						},
						{
							id: 2,
							name: "设备位置",
							routeName: "Location",
							route: "deviceLocation"
						}
						]
                    },
					
					{
						id: 3,
						name: '用户管理',
						route: "userManage",
						icon:'icon-Management',
						routeName: "User",
						children: [{
							id: 1,
							name: "用户管理",
							routeName: "User",
							route: "userManage"
						}]
					},
					{
						id: 14,
						name: '安装商管理',
						route: "Installer",
						icon:'icon-jianshe',
						routeName: "Installer",
						children: [{
							id: 1,
							name: "安装商管理",
							routeName: "Installer",
							route: "installerManage"
						}]
					},
                    {
						id:4,
						name: '固件中心',
						route: "firmwareCenter",
						routeName: "firmwareCenter",
						icon:'icon-gujianguanli',
						children: [
						// {
						// 	id: 1,
						// 	name: "固件管理",
						// 	routeName: "firmwareVersion",
						// 	route: "firmwareVersion"
						// },
						{
							id: 2,
							name: "计划管理",
							routeName: "firmwarePlan",
							route: "firmwarePlan"
						},
						{
							id: 3,
							name: "下载历史",
							routeName: "firmwareDownload",
							route: "firmwareDownload"
						}]
                    },
                    {
						id: 5,
						name: '应用中心',
						route: "AppCenter",
						routeName: "AppCenter",
						icon:'icon-yingyong',
						children: [
                            {
                                id: 1,
                                name: "版本管理",
								routeName: "appVersion",
                                route: "appVersion"
                            },
                            // {
                            //     id: 2,
                            //     name: "页面升级",
							// 	routeName: "appDevice",
                            //     route: "appDevice"
                            // },
                            {
                                id: 3,
                                name: "计划管理",
								routeName: "appPlan",
                                route: "appPlan"
                            },
							{
							    id: 4,
							    name: "下载历史",
							    routeName: "appDownload",
							    route: "appDownload"
					    	},
							{
                                id: 5,
                                name: "引导页",
								routeName: "onboardingBanner",
                                route: "onboardingBanner"
                            },
                        ]
                    },
                    {
						id: 6,
						name: '交易中心',
						route: "AccountCenter",
						routeName: "AccountCenter",
						icon:'icon-jiaoyizhongxin-01',
						children: [
                            {
                                id: 1,
                                name: "月度短信",
								routeName: "SMScost",
                                route: "SMScost"
                            },
                            {
                                id: 2,
                                name: "充值管理",
								routeName: "accountRecharge",
                                route: "accountRecharge"
                            },
                            {
                                id: 3,
                                name: "交易历史",
								routeName: "accountHistory",
                                route: "accountHistory"
                            }
                        ]
                    },
					{
						id: 7,
						name: '登录统计',
						route: "Login",
						routeName: "Login",
						icon:'icon-gupiao',
						children: [{
							id: 1,
							name: "登录统计",
							routeName: "Login",
							route: "loginStatistics"
						}]
                    },
					 {
						id: 8,
						name: '反馈信息',
						route: "feedBack",
						routeName: "feedBack",
						icon:'icon-fankui',
						children: [
                            {
                                id: 1,
                                name: "反馈信息",
								routeName:'feedBack',
                                route: "feedBack"
                            }
                        ]
                    },
                    {
						id: 9,
						name: '推送信息',
						route: "pushMessage",
						routeName:'pushMessage',
						icon:'icon-tuisong',
						children: [
                            {
                                id: 1,
                                name: "推送信息",
								routeName:'pushMessage',
                                route: "pushMessage"
                            },
                        ]
					},
					{
						id:10,
						name: '配置管理',
						route: "setting",
						routeName:'setting',
						icon:'icon-shezhi1',
						children: [
                            {
                                id: 1,
                                name: "设置",
								routeName:'setting',
                                route: "setting"
                            }
                        ]
					},
		
					// {
					// 	id: 112,
					// 	title: '测试',
					// 	children: [{
					// 		id: 1,
					// 		title: "测试",
					// 		routerUrl: "modelss"
					// 	}]
					// },
				],
				memuList4: [// roleType==3
			     	{
						id: 0,
						name: '平台首页',
						routeName:'home',
						icon:'icon-activeHome-copy-copy-copy',
						children: [{
							id: 1,
							name: "平台首页",
							routeName:'home',
							route: "/"
						   }
						]
					},
					{
						id: 1,
						name: '产品管理',
						routeName:'Products',
						icon:'icon-guanli',
						children: [{
							id: 1,
							name: "产品管理",
							routeName:'Products',
							route: "productManage"
						   }
						]
					},
					{
						id: 6,
						name: '设备管理',
						route: "DeviceCenter",
						routeName: "DeviceCenter",
						icon:'icon-shebeiguanli',
						children: [{
							id: 1,
							name: "设备管理",
							routeName: "Device",
							route: "deviceManage"
						},
						// {
						// 	id: 2,
						// 	name: "设备位置",
						// 	routeName: "Location",
						// 	route: "deviceLocation"
						// }
						]
                    },
					{
						id: 7,
						name: '设备管理',
						route: "DeviceCenter",
						routeName: "DeviceCenter",
						icon:'icon-shebeiweizhi',
						children: [
						{
							id: 2,
							name: "设备位置",
							routeName: "Location",
							route: "deviceLocation"
						}
						]
                    }
				],
				activeObj: '',
				openedNames:'',
				memuListarr:[]
			};
		},
		computed: {
			...mapState(['tabList','local','showLeftPx','showChildrenSide']),
			getSelectMenuItem() {
				return this.$store.state.selectMenuItem
			},
			roleType(){
	         	 let res = '3'
	         	 if(this.$store.state.uInfo && this.$store.state.uInfo.roleType){
	         		 res = this.$store.state.uInfo.roleType
	         	 }
	         	 return res
	        },
		},
		watch: {
			getSelectMenuItem: {
				deep:true,
				handler(newValue, oldValue) {
					this.activeObj = newValue
					this.selectMenuItem = newValue
					this.openedNames = this.activeObj.fId+'A'

					this.$nextTick(()=>{
			        	this.$refs.menu.updateOpened()
			        	this.$refs.menu.updateActiveName()
			        })
				}
			},
			showChildrenSide(newVal,oldVal){

                if(newVal){
					this.memuList = this.memuList1
				}else if(this.roleType==1){
			    	this.memuList = this.memuList3
			    }else if(this.roleType==2){
			    	this.memuList = this.memuList2
			    }else if(this.roleType==3){
			    	this.memuList = this.memuList4
			    }
				// this.$store.commit('setSideList',this.memuList)
			},
			'$route' (to) {
                if(to.name=='home'){ 
					this.colorHome = '#4ABAF0'
				}
            }

		},
		methods: {
			init(){
				// console.log(7777)
                // let hostUrl = window.location.assign.origin
                // this.hostUrl = hostUrl
			    // if (this.getSelectMenuItem) {
			    // 	this.activeObj = this.getSelectMenuItem
			    // 	this.openedNames = this.activeObj.fId+'A'
			    // 	this.$nextTick(()=>{
			    //     	this.$refs.menu.updateOpened()
			    //     	this.$refs.menu.updateActiveName()
			    //     })
			    // }

				

				let hostUrl = window.location.assign.origin
                this.hostUrl = hostUrl
			    if (this.getSelectMenuItem) {
			    	this.activeObj = this.getSelectMenuItem
			    	this.openedNames = this.activeObj.fId+'A'
			    	this.$nextTick(()=>{
			        	this.$refs.menu.updateOpened()
			        	this.$refs.menu.updateActiveName()
			        })
			    	// console.log('this.openedNames',this.getSelectMenuItem)
			    }

				if(this.$route.path != '/' && this.$route.path != '/home'){
                    if(this.tabList.length==1){
					   this.toList(this.memuList)
					//    console.log(this.memuListarr)
                       this.memuListarr.map((item,index)=>{
						//    console.log('/'+item.route,this.$route.path,'/'+item.route==this.$route.path)
						   if('/'+item.route==this.$route.path && item.fid){
							//    console.log(9999999)
							   this.selectMenu(item.fid+'-'+item.id)
						   }
					   })
                    }
                }
			},
			toList(arr,fid=0){
                for(let i of arr){
                    let obj = {...i,fid}
                    delete obj.children
                    this.memuListarr.push(obj)
                    if(i.children){
                        this.toList(i.children,i.id)
                    }
                }
			},
			getSide() {
			// 	this.axios.get(this.config.urlArray.getSide, {}) .then(result => {
            //         common.ajaxMsg(result.data);
            //         this.$nextTick(() => {
            //           let sideList = result.data.data;
            //           sideList.map((item,index)=>{
            //               item.router_name = item.route
            //               if(item.children){
            //                   item.children.map((item1,index1)=>{
            //                       item1.router_name = item1.route
            //                       return item1
            //                   })
            //               }
            //               return item
            //           })
            //           this.memuList = sideList;
			// 		//   console.log(this.memuList)
            //          });
            //    }).catch(err => {
            //     common.msg("error", "侧栏获取失败", () => {});
            //    });
			    if(this.showChildrenSide){
                   this.memuList = this.memuList1
			    }else if(this.roleType==1){
			    	this.memuList = this.memuList3
			    }else if(this.roleType==2){
			    	this.memuList = this.memuList2
			    }else if(this.roleType==3){
			    	this.memuList = this.memuList4
			    }
            },
			onMenuSelect(name) {},
			gohome() {
				let itemObj = {
					activeId: 'fhome-shome',
					fId: 'fhome',
					fTitle: '首页',
					sId: 'shome',
					sTitle: '首页',
					routeName:'home',
					routerUrl: 'home'
				}
                this.colorHome = "#4ABAF0";
                this.$store.commit('setSlideItem', itemObj)
                this.$router.push({ name: 'home' })
			},
			selectMenu(name) {
				// console.log(name)
                this.colorHome = "";
				if (this.$store.state.tabList.length >= 50) {
					common.msg("error", "标签最多只可添50个请删除后再操作", () => {});
					return
				}
				let menuItem = name.split('-')

				let offIndex1 = this.memuList.findIndex((mitem, index) => {
					return mitem.id == menuItem[0]
				})
				let offIndex2 = this.memuList[offIndex1].children.findIndex((mitem, index) => {
					return mitem.id == menuItem[1]
				})

				let fObj = this.memuList[offIndex1]
				let sObj = this.memuList[offIndex1].children[offIndex2]
				let itemObj = {
					activeId: name,
					fId: fObj.id,
					fTitle: fObj.name,
					sId: sObj.id,
					sTitle: sObj.name,
					routeName:sObj.routeName,
					routerUrl: sObj.route
				}
            //    console.log('itemObj.route',itemObj)
               // console.log('sObj',sObj)
               this.$store.commit('setSlideItem', itemObj)
               this.$router.push({ path: itemObj.routerUrl })  
		    }
		},
		created() {
			this.getSide()
            this.init()

		},
		mounted() {
			// console.log('this.showChildrenSide',this.showChildrenSide)
		
        }
	};
</script>
<style scoped>
	.ivu-menu-vertical .ivu-menu-item:hover,
	.ivu-menu-vertical .ivu-menu-submenu-title:hover{
		background: #fff !important;
		color: #4ABAF0 !important;
		border-radius: 10px;
	}

	.ivu-menu {
		background: #ffffff;
	}

	.ivu-menu-submenu-title {
		background: #ffffff;
	}
	.menuItemW{
		/* background: #ffffff !important; */
		margin: 5px 15px;
		text-align: center;
		position: relative;
		height: 46px;
	}
	/* .ivu-menu-vertical #menuItemW:hover{
		background: #fff !important;
		color: #4ABAF0 !important;
		border-radius: 10px;
	} */
	.ivu-menu-submenu{
		text-align: center;
	}
	.ivu-menu-item>i {
       margin-right: 10px;
    }
    .test{
		width: 82px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: absolute;
        left: 50%;
		top: 50%;
        transform: translate(-50%,-50%);
		/* width: 100%;
	    height: 100%;
	    padding-left: 15%;
	    box-sizing: border-box; */
		
	}
	.test .ivu-icon{
		margin-right: 10px;
	}

</style>

<style scoped>
	.img-cions {
		font-size: 20px;
		margin: 0px 5px 0px 10px;
	}
	.labelImg{
		width: 20px;
		height: 20px;
		margin: 0px 5px 0px 0px;
	}

	/* .ivu-layout-sider {
		z-index: 1;
		width:280px !important;
		min-width: 280px !important;
        max-width: 280px !important;
        flex: 0 0 280px !important;
		background-color: #ffffff;
	} */
	.ivu-layout-sider {
		z-index: 1;
		width:260px !important;
		min-width: 260px !important;
        max-width: 260px !important;
        flex: 0 0 260px !important;
		background-color: #ffffff;
		transition: all .3s ease-in-out;
	}

	a {
		color: rgba(255, 255, 255, 0.7) !important;
	}

	.homeTip {
		cursor: pointer;
	}

	.homeTip img {
		width: 30px;
		height: 30px;
	}

	.homeTip span {
    color: #fff;
		margin: 0px 10px;
	}

	.homeTip:hover span {
		color: #ffffff;
	}

	.homeTip {
		padding: 17px 15px;
		box-sizing: border-box;
		text-align: left;
		font-size: 16px;
		display: flex;
		align-items: center;
		justify-content: left;
	}

	.homeTip:hover {
		background: #4ABAF0;
	}

	/* 菜单悬浮高亮 */
	.ivu-menu-dark.ivu-menu-vertical .ivu-menu-submenu .ivu-menu-item:hover {
		background: #4ABAF0;
		color: #ffffff;
		border-radius: 10px;
	}

	.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
		/* color: #4ABAF0;
		background: #4ABAF0; */
		color: #ffffff !important;
		background-color:#4ABAF0 !important;
		border-radius: 10px;
	}


	.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu):after {
		background: #fff;
	}
	.ivu-menu-vertical.ivu-menu-light:after{
		background: #fff;
	}

	/* .ivu-menu-submenu:hover,.ivu-menu-submenu:hover i{
    background: #4ABAF0 !important;
    color: #ffffff  !important;
} */
	.layout-con {
		height: 100%;
		width: 100%;
	}

	.menu-item span {
		display: inline-block;
		overflow: hidden;
		width: 69px;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: bottom;
		transition: width 0.2s ease 0.2s;
	}

	.menu-item i {
		transform: translateX(0px);
		transition: font-size 0.2s ease, transform 0.2s ease;
		vertical-align: middle;
		font-size: 16px;
	}

	.collapsed-menu span {
		width: 0px;
		transition: width 0.2s ease;
	}

	.collapsed-menu i {
		transform: translateX(5px);
		transition: font-size 0.2s ease 0.2s, transform 0.2s ease 0.2s;
		vertical-align: middle;
		font-size: 22px;
	}

	/* @media only screen and (min-width: 120px) {
        .ivu-menu {
           display: none !important;
        }
    } */
	.ivu-form .ivu-form-item-label {
		max-width: 120px !important;
		text-align: center !important;
		text-indent: 1px;
	}

	.ivu-form-item-content {
		margin-left: 120px !important;
	}

	::-webkit-scrollbar {
		width: 0px;
		height: 4px;
	}

	/*滑动轨道*/
	::-webkit-scrollbar-track {
		border-radius: 0px;
		background: none;
	}

	/*滑块*/
	::-webkit-scrollbar-thumb {
		border-radius: 5px;
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		background-color: rgba(255, 255, 255, 0.75);
	}

	/*滑块效果*/
	::-webkit-scrollbar-thumb:hover {
		border-radius: 5px;
		box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
		background-color: rgba(85, 85, 85, 0.4);
	}

	.menu-view {
		width: 100% !important;
	}




  
</style>

<style lang="less" scoped>
 /deep/ .ivu-menu-submenu-title{
	 padding: 14px 88px !important;
 }
 .icon-gujianguanli{
	font-size:16px !important
 }
</style>